import React, { useState } from 'react';

/**
 * PasswordInput — glass-styled password field with a show/hide eye toggle.
 * Preserves existing `field-input` styling. Toggle icon is an inline SVG so
 * we don't add another dependency. Icon flips between eye (hidden) and
 * eye-off (visible).
 */
export default function PasswordInput({
  value,
  onChange,
  placeholder = '••••••••',
  autoComplete = 'current-password',
  testid,
  toggleTestid,
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="pw-input-wrap">
      <input
        type={visible ? 'text' : 'password'}
        className="field-input pw-input"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        data-testid={testid}
      />
      <button
        type="button"
        className="pw-toggle"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        data-testid={toggleTestid || `${testid || 'pw'}-toggle`}
        tabIndex={-1}
      >
        {visible ? (
          <svg viewBox="0 0 24 24" fill="none" width="20" height="20" aria-hidden="true">
            <path d="M3 3l18 18" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
            <path d="M10.6 6.1A10 10 0 0112 6c6 0 10 6 10 6a13 13 0 01-3 3.4M6.6 6.6A13 13 0 002 12s4 6 10 6a10 10 0 004.4-1" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
            <path d="M14 14a3 3 0 01-4-4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="none" width="20" height="20" aria-hidden="true">
            <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
            <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.7" />
          </svg>
        )}
      </button>
    </div>
  );
}
